export const serverUrl = 'https://app.bodegaenlinea.cl/api/'
export const serverUrlAR = 'https://sync.bol.cl/importDF/'
export const accessToken = 'adsadsdfjasuhdfkuyasdgbyghr43q7f2ugwhuas'